import { useRef, useEffect, useState } from 'react';
import { getActiveState } from '../helpers/titreHelper';
import { useGetParams } from './useGetParams';
import { useInterval } from './useInterval';

export const useBroadcast = () => {
  const { user } = useGetParams();

  const [currentState, setCurrentState] = useState(null);
  const [allStates, setAllStates] = useState({});
  const [isVisible, setIsVisible] = useState(null);

  const [prevRecord, setPrevRecord] = useState(0);
  const [description, setDescription] = useState('');

  const lastMessageIdRef = useRef(0);

  // id предыдущего запущенного интерактива
  const prevIdBroadcast = useRef('');
  // id текущего запущенного интерактива
  const iactiveIdRef = useRef('');

  const protocol = window?.location?.protocol || 'https:';

  const getBroadcastInfo = async () => {
    if (!user) {
      return;
    }

    try {
      const response = await fetch(
        `${protocol}//api.stream.iactive.pro/titreInfo?user=${user}&from=${lastMessageIdRef.current}&type=1`,
        { cache: 'no-store' },
      );
      const data = await response.json();

      if (!data) return;

      let {
        messagesList,
        deletedMessagesIdList,
        visibility,
        iactiveId,
        broadcastDescription,
      } = data;

      // очистка при остановке\смене интерактива, при остановке iactiveId = ""
      if (iactiveIdRef.current !== iactiveId) {
        if (
          iactiveId &&
          iactiveId !== prevIdBroadcast.current // если === , значит prevIdBroadcast был остановлен и теперь запущен, и не нужно обнулять
        ) {
        }
      }

      if (description !== broadcastDescription) {
        setDescription(broadcastDescription);
      }

      // Определяем видимость титра
      if (!visibility && visibility !== isVisible) {
        setIsVisible(false);
        return;
      } else if (visibility && visibility !== isVisible) {
        setIsVisible(true);
      }

      if (data?.statusList[0]?.state) {
        // предыдущий рекорд
        const nameState = JSON.parse(data?.statusList[0]?.state)?.['S6']?.value;
        if (nameState) {
          setPrevRecord(Number(nameState));
        }
      }

      if (JSON.stringify(allStates) !== data?.statusList[0]?.state) {
        setAllStates(JSON.parse(data?.statusList[0]?.state));
      }

      // Определяем состояние (S1, S2 ...)
      if (
        data?.statusList[0]?.state &&
        getActiveState(data?.statusList[0]?.state) !== currentState
      ) {
        setCurrentState(getActiveState(data?.statusList[0].state));
      }

      //запоминаем id последнего сообщения, для дальнейших запросов и обнуляем при переключении интерактивов

      if (iactiveIdRef.current && iactiveIdRef.current !== iactiveId) {
        lastMessageIdRef.current = 0;
        iactiveIdRef.current = iactiveId;
        return;
      } else {
        iactiveIdRef.current = iactiveId;
        lastMessageIdRef.current =
          messagesList[0]?.id || lastMessageIdRef.current;
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getBroadcastInfo();
  }, []);

  // Получение информации о титре
  useInterval(getBroadcastInfo, 1000);

  return {
    currentState,
    isVisible,
    allStates,
    prevRecord,
    description,
  };
};
